import { api } from "../api/apiClient";

const handleError = (error) => {
  console.error("Error:", error);
  throw error;
};

export const getNotifications = async (userId) => {
  try {
    const response = await api.get(`/api/notifications/get-notifications`, {
      params: {
        userId: userId,
      },
    });
    return response.data;
  } catch (error) {
    handleError(error);
  }
};

export const markNotificationAsRead = async (notificationId) => {
  try {
    const response = await api.post(
      `/api/notifications/mark-as-read/${notificationId}`,
    );
    return response.data;
  } catch (error) {
    handleError(error);
  }
};

export const getUnreadNotificationsCount = async (userId) => {
  try {
    const response = await api.get(`/api/notifications/unread-count`, {
      params: {
        userId: userId,
      },
    });
    return response.data;
  } catch (error) {
    handleError(error);
  }
};

export const markAllNotificationsAsRead = async (userId) => {
  try {
    const response = await api.patch(`/api/notifications/read-all`, { userId });
    return response.data;
  } catch (error) {
    handleError(error);
  }
};

/**
 * Hides a notification (used after acting on it, e.g., accepting/declining friend request)
 * @param {string} notificationId
 */
export const hideNotification = async (notificationId) => {
  try {
    const response = await api.patch(
      `/api/notifications/hide/${notificationId}`,
    );
    return response.data;
  } catch (error) {
    handleError(error);
  }
};

/**
 * Saves or updates the PWA push subscription in the backend.
 * @param {string} userId
 * @param {object} subscription
 */
export const savePushSubscription = async (userId, subscription) => {
  try {
    const response = await api.post(`/api/notifications/save-subscription`, {
      userId,
      subscription,
    });
    return response.data;
  } catch (error) {
    handleError(error);
  }
};
